// extracted by mini-css-extract-plugin
export var marginNegative = "_5v-5 _5v-3 _5v-1";
export var marginPositive = "_5v-4 _5v-3 _5v-1";
export var modalContent = "_5v-6";
export var samplesTable = "_5v-8";
export var samplesTableContainer = "_5v-7";
export var statBox = "_5v-a";
export var tableCell = "_5v-1";
export var tableCellCenter = "_5v-2 _5v-1";
export var tableCellRight = "_5v-3 _5v-1";
export var tableHeader = "_5v-0";
export var trackingNumber = "_5v-9";